import React from "react";
import cx from "classnames";

import styles from "./Spinner.module.scss";

export function Spinner({
  height = 80,
  width = 80,
  color = "primary",
  className,
}: {
  height?: number;
  width?: number;
  color?: "primary" | "invert";
  className?: string;
}) {
  return (
    <svg
      className={cx(styles.Spinner, className)}
      width={width}
      height={height}
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color === "primary" ? "#2196f3" : "white"}
      aria-label="audio-loading"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18"></circle>
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
          </path>
        </g>
      </g>
    </svg>
  );
}

